import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconChevronDoubleLeft= ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className} ${sizeOption}`}
  >
    <path
      d="m11 19-7-7 7-7m8 14-7-7 7-7"
      stroke="#1C1F2B"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}
